export default "__VITE_ASSET__CLWxbiLO__"